import { render, staticRenderFns } from "./RestoreAttachBackupVolume.vue?vue&type=template&id=025ba788&scoped=true&"
import script from "./RestoreAttachBackupVolume.vue?vue&type=script&lang=js&"
export * from "./RestoreAttachBackupVolume.vue?vue&type=script&lang=js&"
import style0 from "./RestoreAttachBackupVolume.vue?vue&type=style&index=0&id=025ba788&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025ba788",
  null
  
)

export default component.exports